import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, Button, FormControl, Modal, Form, Badge } from 'react-bootstrap';
import s from './PromoCodeList.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import messages from '../../../../locale/messages';
import moment from 'moment';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { graphql } from 'react-apollo';
import Link from '../../../Link'
import PropTypes from 'prop-types';
import { FaFilter } from 'react-icons/fa';

// Components
import CustomPagination from '../../../CustomPagination';
import CurrencyConverter from '../../../CurrencyConverter';

//Images
import TrashIcon from '../../../../../public/Icons/bin.svg';
import EditIcon from '../../../../../public/Icons/edit.png';
import addIcon from '../../../../../public/Icons/addNewIcon.svg';

import { deletePromoCode } from '../../../../actions/siteadmin/PromoCode/deletePromoCode';
import { addPromoCode } from '../../../../actions/siteadmin/PromoCode/addPromoCode';

import getAllPromoCode from './getAllPromoCode.graphql';
import getLocationsQuery from '../../../../routes/site-admin/serviceFee/getLocations.graphql';

class PromoCodeList extends React.Component {
  static propTypes = {
    deleteDriver: PropTypes.any
  };

  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0,
      showFilterModal: false,
      location: '',
      status: ''
    }

    this.paginationData = this.paginationData.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.openFilterModal = this.openFilterModal.bind(this);
    this.closeFilterModal = this.closeFilterModal.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  openFilterModal() {
    this.setState({ showFilterModal: true });
  }

  closeFilterModal() {
    this.setState({ showFilterModal: false });
  }

  applyFilters() {
    const { promoCodes: { refetch } } = this.props;
    const { searchList, location, status } = this.state;
    this.setState({ currentPage: 1, showFilterModal: false });
    refetch({
      currentPage: 1,
      searchList,
      locationId: location ? parseInt(location, 10) : null,
      status: status || null
    });
  }

  clearFilters() {
    const { promoCodes: { refetch } } = this.props;
    const { searchList } = this.state;
    this.setState({ currentPage: 1, location: '', status: '', showFilterModal: false });
    refetch({ currentPage: 1, searchList, locationId: null, status: null });
  }

  handleSearchClick(searchList) {
    const { promoCodes: { refetch } } = this.props;
    const { location, status } = this.state;
    this.setState({ currentPage: 1 });
    refetch({
      currentPage: 1,
      searchList,
      locationId: location ? parseInt(location, 10) : null,
      status: status || null
    });
  }

  handleSearchChange(e) {
    let self = this
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout)
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleSearchClick(self.state.searchList)
      }, 450)
    })
  }

  async handleChange(e, id, title, description, code, type, promoValue, expiryDate, isPrivate) {
    const { addPromoCode, promoCodes: { refetch } } = this.props;
    let data = {};
    data = {
      id: id,
      title: title,
      description: description,
      code: code,
      type: type,
      promoValue: promoValue,
      isEnable: e.target.value,
      expiryDate,
      isPrivate
    }
    this.setState({ currentPage: 1 });
    let variables = { currentPage: 1 };
    await addPromoCode(data);
    refetch(variables);
  }

  async handleDelete(id, currentPage) {
    const { deletePromoCode, promoCodes: { refetch } } = this.props;
    this.setState({ currentPage: 1 });
    await deletePromoCode(id);
    refetch({ currentPage: 1 });
  }

  paginationData(currentPage) {
    const { promoCodes: { refetch } } = this.props;
    const { searchList, location, status } = this.state;
    this.setState({ currentPage });
    refetch({
      currentPage,
      searchList,
      locationId: location ? parseInt(location, 10) : null,
      status: status || null
    });
  }

  isPromoCodeExpired(expiryDate) {
    if (!expiryDate) return false;
    return moment(expiryDate).isBefore(moment());
  }

  render() {
    const { promoCodes, promoCodes: { getPromoCodes }, currency, getLocationsData } = this.props;
    const { currentPage, loading, showFilterModal, location, status } = this.state;
    const { formatMessage } = this.props.intl;

    const filterCount = (location ? 1 : 0) + (status ? 1 : 0);

    return (
      <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
        <div className={cx(s.exportDisplay, s.tabelExport)}>
          <div className={'textAlignRightRTL'}>
            <div className={s.searchFilterRow}>
              <FormControl type='text' placeholder={formatMessage(messages.search)} onChange={(e) => this.handleSearchChange(e)} className={s.formControlInput} />
              <Button className={s.filterButton} variant="outline-dark" onClick={this.openFilterModal}>
                <FaFilter className='mr-1' />
                Filter {filterCount > 0 && <Badge variant="danger" className="ml-1">{filterCount}</Badge>}
              </Button>
            </div>
          </div>
          <div className={cx(s.exportTextSection, 'textAlignLeftRTL')}>
            <div className={cx(s.paddingTop2)}>
              <Link to={'/siteadmin/promo-code/add'} className={s.addlinkBtn}>
                <FormattedMessage {...messages.addPromoCode} />
                <span className={cx(s.addIconCss, 'addIconCssRTL')}><img src={addIcon} /></span>
              </Link>
            </div>
          </div>
        </div>
        <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
          <Table className={cx("table")}>
            <thead>
              <tr>
                <th scope="col"><FormattedMessage {...messages.id} /></th>
                <th scope="col"><FormattedMessage {...messages.code} /></th>
                <th scope="col"><FormattedMessage {...messages.title} /></th>
                <th scope="col"><FormattedMessage {...messages.discount} /></th>
                <th scope="col"><FormattedMessage {...messages.promoType} /></th>
                <th scope="col"><FormattedMessage {...messages.status} /></th>
                <th scope="col">Usage</th>
                <th scope="col"><FormattedMessage {...messages.action} /></th>
              </tr>
            </thead>
            <tbody>
              {
                promoCodes && promoCodes.getPromoCodes && promoCodes.getPromoCodes.data && promoCodes.getPromoCodes.data.length > 0 && promoCodes.getPromoCodes.data.map((item, index) => {
                  const isExpired = this.isPromoCodeExpired(item.expiryDate);
                  return (
                    <tr key={index} className={cx(isExpired && s.expiredRow)}>
                      <td data-label={formatMessage(messages.id)}>{item && item.id}</td>
                      <td data-label={formatMessage(messages.code)}><code>{item && item.code}</code></td>
                      <td data-label={formatMessage(messages.title)}>{item && item.title}</td>
                      <td data-label={formatMessage(messages.discount)}>
                        {
                          item && item.type === 1 ?
                            <span>
                              {item.promoValue + '%'}
                            </span>
                            :
                            <CurrencyConverter
                              amount={item.promoValue}
                              from={item.currency}
                              toCurrency={currency}
                            />
                        }
                      </td>
                      <td>{item.isPrivate ? 'private' : 'public'}</td>
                      <td data-label={formatMessage(messages.status)}>
                        {isExpired ? (
                          <span className={cx(s.expiredLabel, 'text-muted')}>
                            Expired
                          </span>
                        ) : (
                          <select
                            name="isEnable"
                            onChange={(e) => this.handleChange(e, item.id, item.title, item.description, item.code, item.type, item.promoValue, item.expiryDate, item.isPrivate)}
                            value={item.isEnable}
                            className={s.selectInput}
                          >
                            <option value="true">{formatMessage(messages.active)}</option>
                            <option value="false">{formatMessage(messages.inactive)}</option>
                          </select>
                        )}
                      </td>
                      <td data-label="Usage">
                        <span className={cx(s.usageBadge, item.usageCount > 0 && s.usageBadgeActive)}>
                          {item.usageCount || 0}
                        </span>
                      </td>
                      <td data-label={formatMessage(messages.action)}>
                        <Link to={'/siteadmin/promo-code/edit/' + item.id} className={cx('editAlignIcon', s.editColorIcon)}>
                          <span><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                          <span className={s.vtrMiddle}>
                            <FormattedMessage {...messages.editAction} />
                          </span>
                        </Link>
                        <Button onClick={() => this.handleDelete(item.id, currentPage)} className={cx(s.iconBtn, 'iconBtnRTL')} disabled={loading}>
                          <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                          <span className={s.vtrMiddle}>
                            <FormattedMessage {...messages.deleteAction} />
                          </span>
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
              {
                promoCodes && promoCodes.getPromoCodes && promoCodes.getPromoCodes.data && promoCodes.getPromoCodes.data.length == 0 && (
                  <tr>
                    <td colspan="12" className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                  </tr>
                )
              }
            </tbody>
          </Table>
        </div>
        {
          promoCodes && promoCodes.getPromoCodes && promoCodes.getPromoCodes.count > 0
          && <div className={cx(s.space5, s.spaceTop5)}>
            <CustomPagination
              total={promoCodes.getPromoCodes.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.promoCodeId)}
            />
          </div>
        }

        <Modal show={showFilterModal} onHide={this.closeFilterModal} centered>
          <Modal.Header>
            <Modal.Title>Filter Promo Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label><FormattedMessage {...messages.location} /></Form.Label>
              <FormControl
                as="select"
                value={location}
                onChange={e => this.setState({ location: e.target.value })}
              >
                <option value="">{formatMessage(messages.allLocations)}</option>
                {getLocationsData && getLocationsData.getLocations && getLocationsData.getLocations.map(loc => (
                  <option key={loc.id} value={loc.id}>{loc.locationName}</option>
                ))}
              </FormControl>
            </Form.Group>
            <Form.Group>
              <Form.Label><FormattedMessage {...messages.status} /></Form.Label>
              <FormControl
                as="select"
                value={status}
                onChange={e => this.setState({ status: e.target.value })}
              >
                <option value="">Semua Status</option>
                <option value="active">{formatMessage(messages.active)}</option>
                <option value="inactive">{formatMessage(messages.inactive)}</option>
                <option value="expired">Expired</option>
              </FormControl>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.clearFilters}>
              Reset
            </Button>
            <Button variant="primary" onClick={this.applyFilters}>
              Terapkan
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapState = (state) => ({
  loading: state.loader.deletePromoCode
});
const mapDispatch = {
  deletePromoCode,
  addPromoCode
};

export default compose(
  withStyles(s),
  injectIntl,
  graphql(getAllPromoCode, {
    name: 'promoCodes',
    options: {
      variables: {
        currentPage: 1,
        searchList: ''
      },
      ssr: true,
      fetchPolicy: 'network-only'
    }
  }),
  graphql(getLocationsQuery, {
    name: 'getLocationsData'
  }),
  connect(mapState, mapDispatch)
)(PromoCodeList);
